import { render, staticRenderFns } from "./EditSeatingStrategyPrefeHighTableCapacityUsage.vue?vue&type=template&id=c623e66e&"
import script from "./EditSeatingStrategyPrefeHighTableCapacityUsage.vue?vue&type=script&lang=js&"
export * from "./EditSeatingStrategyPrefeHighTableCapacityUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports